import { Link } from "react-router-dom";
import { Car, Bike, Truck, Caravan, CarFront, Route } from "lucide-react";
import { Reveal } from "./motion";

const SERVICES = [
  { icon: Car, title: "Cars, SUVs & Pickups", desc: "Passenger cars of every make and model, including sedans, coupes, SUVs and pickup trucks.", to: "/services/california-vin-verification" },
  { icon: Route, title: "Out-of-State Cars", desc: "Bringing a car into California? We provide the mobile VIN verification needed for registration.", to: "/services/out-of-state-vin-verification" },
  { icon: CarFront, title: "Classic & Collector Cars", desc: "Vintage, collector, restored and specialty passenger vehicles.", to: "/services/classic-car-vin-verification" },
  { icon: Bike, title: "Motorcycles", desc: "Street bikes, cruisers, dirt bikes and scooters.", to: "/services/motorcycle-vin-verification" },
  { icon: Truck, title: "Trailers", desc: "Travel, fifth-wheel, toy hauler, utility, cargo, gooseneck and commercial trailers. Boat trailers only — not boats.", to: "/services/trailer-vin-verification" },
  { icon: Caravan, title: "RVs & Campers", desc: "Class A/B/C motorhomes, truck campers, travel trailers and fifth wheels.", to: "/services/rv-vin-verification" },
];

export default function Services() {
  const go = () => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-brand font-semibold text-sm tracking-wide uppercase">What We Verify</p>
          <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 max-w-2xl leading-[1.1]">
            Mobile VIN verification for cars — and more
          </h2>
          <p className="text-slate2 text-base sm:text-lg mt-4 max-w-2xl">
            Cars are our main service. A California licensed and bonded vehicle verifier comes to your home or work. We also serve motorcycles, trailers, motorhomes, RVs, commercial vehicles and fleets.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08}>
                <Link to={s.to} data-testid={`service-card-${i}`} className="card-soft block h-full p-7 lg:p-8">
                  <span className="h-14 w-14 rounded-2xl bg-brand/10 flex items-center justify-center text-brand">
                    <Icon size={26} />
                  </span>
                  <h3 className="font-display font-semibold text-ink text-xl mt-5">{s.title}</h3>
                  <p className="text-slate2 text-sm mt-2 leading-relaxed">{s.desc}</p>
                  <span className="text-brand font-semibold text-sm mt-4 inline-block">Learn more →</span>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button data-testid="services-cta" onClick={go} className="btn-accent rounded-full px-7 py-3.5 text-sm font-semibold">
              Book Your Verification
            </button>
            <span className="text-slate2 text-sm">Not sure which applies? Call us — we'll help.</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
